import React from 'react';
import styles from './PageStyles.module.css';
import { motion } from 'framer-motion';

const pageContainerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3, ease: "easeOut" } }
};

const contentBlockVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (custom = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: "easeOut",
            delay: custom * 0.15
        }
    }),
};

const AboutPage = () => {
    return (
        <motion.div
            className={styles.pageContainer}
            variants={pageContainerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.h1
                className={styles.pageTitle}
                variants={contentBlockVariants}
                custom={0}
                initial="hidden"
                animate="visible"
            >
                О проекте Yep
            </motion.h1>

            <motion.section
                className={styles.textBlock}
                variants={contentBlockVariants}
                custom={1}
                initial="hidden"
                animate="visible"
            >
                <p>
                    Проект Yep был основан в июне 2024 года как полноценная экосистема, объединяющая разные направления и сервисы. Название проекта говорит само за себя: Yep означает движение вперед, открытие новых горизонтов и создание пространства для роста.
                </p>
                <p>
                    Однако его история началась гораздо раньше, когда в августе 2023 года была запущена первая версия платформы — Yep&Set. Изначально этот сервис был посвящен моей личной странице дизайна, где я представлял свои работы и проекты. Вдохновившись этой идеей, я решил развить ее дальше и создать нечто большее, что объединяло бы множество сервисов и направлений, полезных для разных людей и компаний.
                </p>
            </motion.section>

            <motion.section
                className={styles.textBlock}
                variants={contentBlockVariants}
                custom={2}
                initial="hidden"
                animate="visible"
            >
                <h2 className={styles.subTitle}>Становление Yep</h2>
                <p>
                    И вот в июне 2024 года Yep стал полноценным проектом, который охватывает несколько сфер, включая игровые аккаунты, прокачку аккаунтов, создание и управление проектами и дизайн. С самого начала основной идеей было создать пространство, где люди смогут легко и безопасно решать свои задачи, будь то покупка, продажа, прокачка аккаунтов или работа с проектами.
                </p>
            </motion.section>

            <motion.section
                className={styles.textBlock}
                variants={contentBlockVariants}
                custom={3}
                initial="hidden"
                animate="visible"
            >
                <h2 className={styles.subTitle}>Наша миссия</h2>
                <p>
                    Мы стремимся предложить удобные и качественные сервисы для разных потребностей. Yep не ограничивается одной сферой, мы предлагаем решения для геймеров, дизайнеров, разработчиков и всех, кто ищет удобные и эффективные способы решения своих задач.
                </p>
                <p>
                    Каждый сервис в нашей экосистеме был создан с одной целью — сделать жизнь пользователей проще, удобнее и безопаснее.
                </p>
            </motion.section>

            <motion.section
                className={styles.textBlock}
                variants={contentBlockVariants}
                custom={4}
                initial="hidden"
                animate="visible"
            >
                <h2 className={styles.subTitle}>Ключевые направления сегодня</h2>
                <p>
                    Сегодня Yep включает такие ключевые направления, как Yep&Sell, Yep&Boost, Yep&Link и Yep&Set. Все эти сервисы представляют собой отдельные, но взаимосвязанные части проекта, который продолжает развиваться и предлагать новые возможности для пользователей. Мы не стоим на месте и постоянно ищем способы улучшить наш опыт, добавляя новые функции и расширяя горизонты.
                </p>
            </motion.section>

            <motion.section
                className={styles.textBlock}
                variants={contentBlockVariants}
                custom={5}
                initial="hidden"
                animate="visible"
            >
                <h2 className={styles.subTitle}>Наше видение</h2>
                <p>
                    Мы гордимся тем, что смогли создать сообщество, которое поддерживает разнообразные интересы и предоставляет эффективные решения. И хотя проект был запущен совсем недавно (относительно июня 2024), мы уже достигли значительных успехов и продолжаем развиваться, двигаясь к нашим амбициозным целям.
                </p>
            </motion.section>
        </motion.div>
    );
};

export default AboutPage;